<template>
	<div>
		<div class="head">
			<h1>{{scheduleDetails.name}}</h1>
			<div class="time">
				<div>
					<p>时间:{{scheduleDetails.start_at}}-{{scheduleDetails.end_at}}</p>
					<p>地址:{{provinceName}} {{cityName}} {{sessionDetail.address}}</p>
				</div>
				<router-link v-if="sessionDetail.is_show_live" class="btn" :to="{path:'/meeting/live',query:{meeting_id:meeting_id,id:scheduleDetails.parallel_session_id}}">
					观看直播
				</router-link>
			</div>
			<div class="host">
				<p v-if="chairman_writers.length>0">
					<b>主席:</b>
					<span v-for="item in scheduleDetails.chairman_writers" :key="item.id">{{item.name}}</span>
				</p>
				<p v-if="host_writers.length>0">
					<b>主持:</b>
					<span v-for="item in scheduleDetails.host_writers" :key="item.id">{{item.name}}</span>
				</p>
				<p v-if="discussor_writers.length>0">
					<b>讨论:</b>
					<span v-for="item in scheduleDetails.discussor_writers" :key="item.id">{{item.name}}</span>
				</p>
				<div>
					<p v-for="item in scheduleDetails.titles" :key="item.id">
						<b>{{item.title}}:</b>
						<span v-for="value in item.writers" :key="value.id">{{value.name}}</span>
					</p>
				</div>
			</div>
		</div>
		<div>
			<div class="time-item" v-for="item in scheduleDetails.details" :key="item.id">
				<div class="time">
					<van-icon name="clock-o" />
					<span>{{item.time}}</span>
				</div>
				<div class="introduction">
					<p class="title">{{item.name}}</p>
					<p class="name" v-for="val in item.writers" :key="val.id">
						<span>{{val.name}}</span>
						<span>{{val.company}}</span>
					</p>
				</div>
			</div>
		</div>
		<return></return>
	</div>
</template>
<script>
	import {MeetingScheduleDetails} from '../../config/interface.js' 
	import Return from '@/components/Meeting/Return'
	export default{
		components:{
			Return
		},
		data(){
			return{
				chapter_id:0,
				meeting_id:0,
				sessionDetail:{},    //会场信息
				scheduleDetails:{},
				chairman_writers:[],   //主席
				discussor_writers:[],   //讨论专家
				host_writers:[],       //主持专家
				provinceName:'',
				cityName:''
			}
		},
		mounted(){
			this.chapter_id=this.$route.query.chapter_id;
			this.meeting_id=this.$route.query.meeting_id;
        	this.sessionSchedule();
		},
		methods:{
			sessionSchedule(){
				const url=MeetingScheduleDetails;
				let params={
					chapter_id:this.chapter_id
				}
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						var data=res.data;
						this.scheduleDetails=data;
						this.scheduleDetails.end_at=this.scheduleDetails.end_at.split(' ')[1];
						this.host_writers=data.host_writers;
						this.discussor_writers=data.discussor_writers;
						this.chairman_writers=data.chairman_writers;
						this.sessionDetail=data.session;
						this.provinceName=this.sessionDetail.city['name'];
						this.cityName=this.sessionDetail.province['name'];

					}
				})
       		}
		}
	}
</script>
<style lang="scss" scoped>
	.head{
		padding:12px;
		border-bottom:1px solid rgba(0,0,0,0.3);
		h1{
			font-size: 15px;
			color: #090909;
			letter-spacing: 0.53px;
		}
		.time{
			margin-top:5px;
			display:flex;
			justify-content: space-between;
			align-items: center;
			p{
				font-size: 13px;
				color: #090909;
				letter-spacing: 0.46px;
				margin-top:5px;
			}
			.btn{
				text-align: center;
				width:74px;
				height:32px;
				line-height:32px;
				background: #901D22;
				color:#fff;
				border-radius: 2px;
			}
		}
		.host{
			margin-top:10px;
			
			p{
				text-align: justify;
				b{
					margin-right:5px;
					font-size:13px;
				}
				span{
					margin-right:5px;
				}
			}
		}
	}
	.time-item{
				padding:14px 12px;
				@include flex(row);
				align-items:center;
				justify-content:space-between;
				.time{
					@include flex(row);
					align-items:center;
					padding:5px 7px;
					font-size:13px;
					color:#fff;
					background-color:$color-gray;
					border-radius:2px;
					background-color:$color-main;
					padding:2px;
					i{
						font-size:15px;
						margin-right:5px;
					}
				}
				.introduction{
					flex:1;
					letter-spacing:.46px;
					margin-left:15px;
					.title{
						color:$color-black;
						font-size:13px;
						margin-bottom:15px;
					}
					.name{
						font-size:11px;
						color:#666;
						margin-bottom:5px; 
					}
					.des{
						font-size:13px;
						word-break: break-all;
						text-align: justify;
					}
				}
				.status{
					width:25px;
					height:15px;
					margin-left:15px;
					background-size:cover;
					background-position:center;
				}
	}
	.time-item:not(:last-child){
		border-bottom:1px solid #bfbfbf;
	}
</style>


// WEBPACK FOOTER //
// src/pages/meeting/scheduleDetails.vue